import { Controller } from '@hotwired/stimulus'

// Only attach data-controller="notify" when there's something to react to —
// runs once on connect, no guard against repeat/no-op calls.
export default class extends Controller {
  static values = {
    type: { type: String, default: 'info' },
    message: String,
    closeDialog: Boolean,
    refreshFrame: String,
  }

  connect() {
    toastr[this.typeValue](this.messageValue)
    if (this.closeDialogValue) this.element.closest('dialog')?.close()
    if (this.refreshFrameValue) {
      const frame = document.getElementById(this.refreshFrameValue)
      if (frame) frame.src = window.location.href
    }
  }
}
